'use client';

import ContactInfo from './contactInfo';
import FooterCopyright from './footerCopy';

export default function Footer() {
  return (
    <div
      className="relative h-screen lg:h-[75vh]"
      style={{ clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' }}
    >
      <div className="fixed bottom-0 h-screen lg:h-[75vh] w-full">
        <footer
          className="relative w-full h-full bg-black text-white flex flex-col"
          id="contacto"
        >
          {/* Header del footer */}
          <div className="px-6 lg:px-12 pt-6 lg:pt-12 flex-shrink-0">
            <div className="mb-6 lg:mb-12">
              <h2 className="text-[10vw] lg:text-7xl font-urbanist font-black uppercase tracking-tight leading-none mb-6 text-white">
                Contacto
              </h2>
              <div className="w-full h-px bg-white/20 origin-left" />
            </div>
          </div>

          {/* Sección principal del footer */}
          <div className="px-6 lg:px-12 flex-1 flex items-center">
            <ContactInfo />
          </div>

          {/* Footer Copyright */}
          <div className="flex-shrink-0">
            <FooterCopyright />
          </div>
        </footer>
      </div>
    </div>
  );
}
